import React, { FC } from 'react'

import { mdiArrowLeft } from '@mdi/js'
import Icon from '@mdi/react'

import { white } from '@constants/colors'
import { IWalkthroughItem } from '@interfaces/components/molecules/WalkthroughItem'

import './styles.scss'

const WalkthroughItem: FC<IWalkthroughItem> = ({
  index,
  total,
  title,
  content,
  closeLabel,
  onBackClick,
  onNextClick,
}) => {
  return (
    <div className="WIContainer">
      <div className="WIText body-large-font">
        {index + 1}/{total}
      </div>
      <div className="WIText body-large-bold-font">{title}</div>
      <div className="WIText body-large-font white-space-pre-wrap">{content}</div>
      <div className="mt-3 d-flex justify-content-between align-items-center w-100">
        {index > 0 ? (
          <div className="clickable" onClick={onBackClick}>
            <Icon path={mdiArrowLeft} size={1} color={white} />
          </div>
        ) : (
          <div />
        )}
        <div className="WIButton clickable" onClick={onNextClick}>
          {index + 1 >= total ? closeLabel : 'Next'}
        </div>
      </div>
    </div>
  )
}

export default WalkthroughItem
